/* eslint-disable import/no-default-export */
import styled from 'styled-components';

const colors = require('common/lib/colors/colors.less');
import fontFamily from '../data/font-family';

const Button = styled.button`
  background-color: transparent;
  border: none;
  color: ${colors['near-black']};
  font-family: ${fontFamily};
  font-size: 12px;
  height: 16px;
  letter-spacing: -0.3px;
  line-height: 1.33;
  padding: 0;
  text-align: center;
`;

export default Button;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/Button.js